import '../scss/education-detail.scss';

import $ from 'jquery';
global.jQuery = $;
window.jQuery = $; window.$ = $;

import 'bootstrap/js/dist/collapse';
import 'lazysizes';
import 'lazysizes/plugins/video-embed/ls.video-embed';

import '../common';
import {createComment, readComments} from '../components/comment';
import saveRating from '../components/rating';
import {makeResponsive} from "../components/responsitive";
import buyModalForm from "../components/buyModalForm";

makeResponsive();
createComment();
readComments();
saveRating();
buyModalForm();